<template>
  <form-dialog v-model="isActive"
               :sending="sending"
               fullscreen
               :title="$t('unita_mobili.azioni.aggiungi_magazzino')"
               @confirm="onConfirm">

    <v-btn slot="btn-confirm" slot-scope="{ validateFunction }" v-if="!$store.getters.isAbbonamentoExpired"
           color="accent" @click="validateFunction" :disabled="nuovoCarico.length <= 0" :loading="sending">
      {{$t('azioni.conferma') }}
    </v-btn>

    <v-flex xs12 sm7>
      <products-data-table :headers="[{text: $t('prodotti.label.nome'), value: 'name', sortable: true, width: 65},
                                      {text: $t('prodotti.label.quantita_disponibile'), value: 'quantita', sortable: true, width: 20, right: true},
                                      {text: '', value: 'addable', width: 15}]"
                           :prodotti="magazzino" :loading="loading" show-filters :title="$t('header.magazzino')"
                           :rows-per-page="10"
                           @click:add="addToCarico" width-auto>

        <template slot="btn-add" slot-scope="{ item, index }">
          <v-tooltip bottom :open-delay="1000">
            <v-btn color="accent" flat icon slot="activator" class="my-0"
                   @click.stop="addToCarico(item, index)" :disabled="isInCarico(item.sku) || item.quantita === 0">
              <v-icon>add</v-icon>
            </v-btn>
            <span>{{ $t('unita_mobili.azioni.aggiungi_carico') }}</span>
          </v-tooltip>
        </template>

      </products-data-table>
    </v-flex>

    <!-- Nuovo carico unità mobile -->
    <v-flex xs12 sm5>
      <products-data-table :headers="[{text: $t('prodotti.label.nome'), value: 'name', sortable: true, width: 50},
                                      {text: $t('prodotti.label.quantita'), value: 'quantita', sortable: true, width: 35, right: true},
                                      {text: '', value: 'removable', width: 15, right: true}]"
                           :prodotti="nuovoCarico"
                           :rows-per-page="11"
                           width-auto :no-data-text="$t('magazzino.messaggi.seleziona_prodotto_lista')"
                           @click:remove="(item, index) => { nuovoCarico.splice(index, 1) }"/>
    </v-flex>

  </form-dialog>
</template>

<script>
import Toggleable from '@/mixins/toggleable'
import FormDialog from '@/components/base/FormDialog'
import ProductsDataTable from '@/components/ProductsDataTable'

export default {
    name: 'UnitaMobileCaricoMagazzinoDialog',
    components: { FormDialog, ProductsDataTable },
    mixins: [Toggleable],
    data: () => ({
        sending: false,
        loading: false,
        targa: null,
        magazzino: [],
        nuovoCarico: []
    }),
    watch: {
        isActive (val) {
            if (val) this.fetchMagazzino()
        },
        targa () {
            this.nuovoCarico.splice(0, this.nuovoCarico.length)
        }
    },
    methods: {
        show (targa) {
            this.targa = targa
            this.isActive = true
        },
        addToCarico (item, index) {
            this.nuovoCarico.push({
                ...item,
                quantita: 1,
                quantitaMax: item.quantita,
                quantitaEditable: true
            })
        },
        isInCarico (sku) {
            return this.nuovoCarico.findIndex(item => item.sku === sku) !== -1
        },
        clearCarico () {
            this.nuovoCarico.splice(0, this.nuovoCarico.length)
        },
        fetchMagazzino () {
            this.loading = true
            this.$api.magazzino.getInternalAll().then(response => {
                this.magazzino = response.data
                this.loading = false
            }).catch(e => {
                this.$snackbar.showServerError(e)
                this.loading = false
            })
        },
        onConfirm () {
            this.sending = true
            //  Filtro i prodotti mantenedo solo sku e quantita
            let filteredCarico = this.nuovoCarico.map(({ sku, quantita, produttore }) => ({ sku, quantita, produttore }))
            this.$api.unitaMobili.caricaProdotti(this.targa, filteredCarico).then(response => {
                this.sending = false
                this.isActive = false
                this.clearCarico()
                this.$snackbar.show(this.$t('unita_mobili.messaggi.prodotti_aggiunti'), 'success')
                this.$emit('success')
            }).catch(e => {
                this.sending = false
                this.$snackbar.showServerError(e)
            })
        }
    }
}
</script>
